<template>
    <div class="culture">
        <transition appear
                v-on:before-enter="beforeEnterCultureContent"
                v-on:enter="enterCultureContent">
            <div class="culture-content__container">
                <h2 class="culture-content__heading">Culture</h2>

                <ul class="culture-content__page-counter-list">
                    <li class="culture-content__page-counter-item">
                        <router-link class="culture-content__page-counter-link" to="/work"></router-link>
                    </li>

                    <li class="culture-content__page-counter-item">
                        <router-link class="culture-content__page-counter-link active" to="/culture"></router-link>
                    </li>

                    <li class="culture-content__page-counter-item">
                        <router-link class="culture-content__page-counter-link" to="/expertise"></router-link>
                    </li>

                    <li class="culture-content__page-counter-item">
                        <router-link class="culture-content__page-counter-link" to="/news"></router-link>
                    </li>

                    <li class="culture-content__page-counter-item">
                        <router-link class="culture-content__page-counter-link" to="/contact"></router-link>
                    </li>
                </ul>

                <button class="culture-content__cta" v-on:click="exploreClick">Explore</button>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavLeft"
                v-on:enter="enterSideNavLeft">
            <div class="culture-side-nav__container--left">
                <router-link class="culture-side-nav__link" to="/work">
                    <h2 class="culture-side-nav__heading">Work</h2>

                    <ul class="culture-side-nav__page-counter-list">
                        <li class="culture-side-nav__page-counter-item active"></li>

                        <li class="culture-side-nav__page-counter-item"></li>

                        <li class="culture-side-nav__page-counter-item"></li>

                        <li class="culture-side-nav__page-counter-item"></li>

                        <li class="culture-side-nav__page-counter-item"></li>
                    </ul>
                </router-link>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavRight"
                v-on:enter="enterSideNavRight">
            <div class="culture-side-nav__container--right">
                <router-link class="culture-side-nav__link" to="/expertise">
                    <h2 class="culture-side-nav__heading">Expertise</h2>

                    <ul class="culture-side-nav__page-counter-list">
                        <li class="culture-side-nav__page-counter-item"></li>

                        <li class="culture-side-nav__page-counter-item"></li>

                        <li class="culture-side-nav__page-counter-item active"></li>

                        <li class="culture-side-nav__page-counter-item"></li>

                        <li class="culture-side-nav__page-counter-item"></li>
                    </ul>
                </router-link>
            </div>
        </transition>

        <video class="culture-video" autoplay muted loop playsinline>
            <source src="/assets/vids/Hunter-Culture.mp4" type="video/mp4">
        </video>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .culture {
        background-color: #003a4a;
        color: #ffffff;
        height: 100vh;
        width: 100%;
        overflow: hidden;
        position: relative;

        &:after {
            content: "";
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 5;
            background: rgba(0, 58, 74, 0.5);
        }
    }

    .culture-content__container {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%) scale(0.1);
        transform-origin: center center;
        transition: all 0.8s ease;
        z-index: 20;

        &.transform-anim {
            transform: translate(-50%, -50%) scale(1);
        }

        .culture-content__heading {
            color: #ffffff;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 96px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0 0 20px;
            text-transform: uppercase;

            @media @breakpoint__tablet--large {
                font-size: 60px;
            }

            @media @breakpoint__mobile--large {
                font-size: 40px;
                margin: 0 0 10px;
            }
        }

        .culture-content__cta {
            background-color: #e40046;
            border: none;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            display: inline-block;
            font-size: 16px;
            letter-spacing: 1px;
            padding: 10px 30px;
            text-decoration: none;
            z-index: 20;

            @media @breakpoint__tablet--small {
                font-size: 14px;
            }
        }

        .culture-content__page-counter-list {
            margin: 0 0 25px;
            padding: 0;

            .culture-content__page-counter-item {
                display: inline-block;
                margin: 0 8px;

                @media @breakpoint__mobile--large {
                    border-radius: 2px;
                    height: 8px;
                    margin: 0 5px;
                    width: 8px;
                }

                .culture-content__page-counter-link {
                    background: #cccccd;
                    border-radius: 3px;
                    display: block;
                    z-index: 1;
                    height: 12px;
                    width: 12px;

                    @media @breakpoint__mobile--large {
                        border-radius: 2px;
                        height: 8px;
                        width: 8px;
                    }

                    &.active {
                        background: #e40046;
                    }
                }
            }
        }
    }

    .culture-side-nav__link {
        text-decoration: none;
    }

    .culture-side-nav__container {
        position: absolute;
        text-align: right;
        top: 52%;
        transform: translate(0, -50%);
        z-index: 10;

        @media @breakpoint__mobile--large {
            top: 49%;
        }

        .culture-side-nav__heading {
            color: #dfe6e8;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 28px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0;
            opacity: 0.8;
            text-transform: uppercase;

            @media @breakpoint__tablet--small {
                font-size: 20px;
            }

            @media @breakpoint__mobile--large {
                font-size: 14px;
            }
        }

        .culture-side-nav__page-counter-list {
            margin: 0;
            padding: 0;

            .culture-side-nav__page-counter-item {
                background: #cccccd;
                border-radius: 1.5px;
                display: inline-block;
                height: 5px;
                margin: 0 3px;
                width: 5px;
                z-index: 1;

                @media @breakpoint__mobile--large {
                    height: 4px;
                    margin: 0 2px;
                    width: 4px;
                }

                &.active {
                    background: #e40046;
                }
            }
        }

        @media @breakpoint__mobile--large {
            display: none;
        }
    }

    .culture-side-nav__container--left {
        .culture-side-nav__container();
        left: 12px;
        text-align: left;

        @media @breakpoint__mobile--large {
            left: 8px;
        }
    }

    .culture-side-nav__container--right {
        .culture-side-nav__container();
        right: 12px;

        @media @breakpoint__mobile--large {
            right: 8px;
        }
    }

    .culture-video {
        height: auto;
        left: 50%;
        min-height: 100%; 
        min-width: 100%; 
        position: absolute;
        top: 50%;
        transform: translate(-50%,-50%);
        width: auto;
        z-index: 0;
    }
</style>

<script>
    export default {
        name: "Culture",
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            beforeEnterCultureContent : function(el) {
                el.style.opacity = 0;

                if (this.$parent._data.animationDirection === "right")
                {
                    el.style.left = "10%";
                }
                else 
                {
                    el.style.left = "90%";
                }

                el.querySelector(".culture-content__cta").style.transform = "scale(0, 0)";
            },
            enterCultureContent : function(el, done)
            {
                TweenMax.to(el, 0.3, {left: "50%", opacity: 1, delay: 0.3});
                TweenMax.set(el, {className:"+=transform-anim", delay: 0.6});
                TweenMax.to(el.querySelector(".culture-content__cta"), 0.8, {transform: "scale(1, 1)", delay: 1.2, ease: Back.easeOut.config(2), onComplete: done});
            },
            exploreClick: function()
            {
                var vm = this;
                TweenMax.to(".culture", 0.4, {opacity: 0, onComplete: vm.goToExplore});
            },
            beforeEnterSideNavLeft :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(-110%)";
            },
            enterSideNavLeft: function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.1});
            },
            beforeEnterSideNavRight :function(el) {
                el.style.opacity = 0;
                el.style.transform = "translateX(110%)";
            },
            enterSideNavRight : function(el, done) {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.1});
            },
            goToExplore: function()
            {
                this.$router.push("/culture/explore");
            }
        }
    };
</script>
